import { NAME } from './constants';
import { router } from './router';
import { apiProvider } from './api';
import { NdPrijemkaPolozky } from './polozky';

export const NdPrijemka = {
	name: NAME,
	NdPrijemkaPolozky,
	router,
	apiProvider,
};
